export const DATA_KEY_ROLE = "mpse__common__const__role__role";
